import { Outlet } from "react-router-dom";
import LandingHeader from "./LandingHeader";
import Footer from "./Footer";

const MarketingLayout = () => {
    return (
        <div className="min-h-screen flex flex-col">
            <LandingHeader />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default MarketingLayout;
